
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security-opening-hours",
      function () {
        return require("private-next-pages/security-opening-hours.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security-opening-hours"])
      });
    }
  